import { ReactElement, ReactNode } from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import Button from 'Root/App/Button'
import Title from 'Root/App/Title'

import styles from './index.module.css'

library.add(faClose)

interface Props {
  children: ReactNode
  title: string | ReactElement
  cta?: ReactNode
  onClose: () => void
}

const PanelLayout: React.FC<Props> = ({ children, title, cta, onClose }) => {
  return (
    <span className={styles.dialogContent}>
      <Dialog.Title className={styles.optionsTitle}>
        <Title>{title}</Title>
        <Button className={styles.dialogCloseButton} onClick={onClose}>
          <FontAwesomeIcon
            className={styles.dialogCloseButtonIcon}
            icon={['fas', 'close']}
          />
        </Button>
      </Dialog.Title>

      {children}

      {cta && <span className={styles.choiceWrapper}>{cta}</span>}
    </span>
  )
}

export default PanelLayout
